import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signalr-error-dialog',
  templateUrl: './signalr-error-dialog.component.html',
  styleUrls: ['./signalr-error-dialog.component.css']
})
export class SignalrErrorDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
